/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    calendarBackgroundColor: '#ffffff',
    calendarDayBlockedCalendarHoverBackground: '#f4f4f7',
    calendarDayBlockedCalendarHoverColor: '#b2b9bf',
    calendarDayDefaultBackgroundColor: '#ffffff',
    calendarDayDefaultBorder: 1,
    calendarDayDefaultBorderColor: '#b2b9bf',
    calendarDayDefaultCalendarDaySelectedHoverBackground: '#ffffff',
    calendarDayDefaultCalendarDaySelectedHoverBeforeBackground: '#7c53a5',
    calendarDayDefaultCalendarDaySelectedHoverColor: '#ffffff',
    calendarDayDefaultColor: '#414547',
    calendarDayDefaultFontName: 'HNforTELUSSA',
    calendarDayDefaultFontSize: 14,
    calendarDayDefaultFontWeight: '400',
    calendarDaySelectedDisabledBackground: '#fafafa',
    calendarDaySelectedDisabledColor: '#ffffff',
    calendarDaySelectedDisabledContentBackgroundColor: '#b2b9bf',
    calendarDaySelectedFocusBeforeBackground: '#ffffff',
    calendarDaySelectedHoverBackground: '#ffffff',
    calendarDaySelectedHoverBeforeBackground: '#ffffff',
    calendarDaySelectedHoverBeforeBorderColor: '#7c53a5',
    calendarDaySelectedHoverBorderColor: '#b2b9bf',
    calendarDaySelectedHoverColor: '#414547',
    calendarMonthCaptionColor: '#2c2e30',
    calendarMonthCaptionFontName: 'HNforTELUSSA',
    calendarMonthCaptionFontSize: 20,
    calendarMonthCaptionFontWeight: '700',
    calendarMonthCaptionLineHeight: 1.4,
    calendarMonthCaptionPaddingBottom: 48,
    dateInputStrokeColor: '#676e73',
    dayPickerNavigationButtonPadding: 8,
    dayPickerWeekHeaderColor: '#414547',
    dayPickerWeekHeaderFontName: 'HNforTELUSSA',
    dayPickerWeekHeaderFontWeight: '700',
    dayPickerWeekHeaderLineHeight: 1.42857142857,
    dayPickerWeekHeaderSmall: 14,
    hiddenInputFieldContainerHeight: 0,
    hiddenInputFieldContainerWidth: 0,
    invalidInputMixin: '#e12339',
    nextIcon: PaletteIconArrowRight,
    previousIcon: PaletteIconArrowLeft,
    singleDatePickerBorderColor: '#676e73',
    singleDatePickerLeftRight: 16,
    singleDatePickerPaddingTopBottom: 8,
    singleDatePickerRadius: 4,
    validInputMixin: '#2b8000'
  }
}
export default theme
